// extracted by css-extract-rspack-plugin
export default {"root":"gojWWH","info-icon":"EZ2M4V","infoIcon":"EZ2M4V"};